import { render, staticRenderFns } from "./field-prompt-draggable-list.vue?vue&type=template&id=f777d478&scoped=true&"
import script from "./field-prompt-draggable-list.vue?vue&type=script&lang=js&"
export * from "./field-prompt-draggable-list.vue?vue&type=script&lang=js&"
import style0 from "./field-prompt-draggable-list.vue?vue&type=style&index=0&id=f777d478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f777d478",
  null
  
)

export default component.exports